import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from '../shared';
import { TenantHdrContainerModel } from '../../../../../models/aggregates/tenant';

@Injectable({
  providedIn: 'root'
})
export class T2TTenantService extends BaseApiTemplateService<TenantHdrContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.T2T_DOMAIN_URL_PREFIX + Core2Config.CONFIG_PREFIX + 'tenants-linking';
    this.httpClient = http;
  }
  // core2/t2t/dm/config/tenants-linking
  sendTenantInvitation(tenantHdr: TenantHdrContainerModel, visa: ApiVisa): Observable<ApiResponseModel<TenantHdrContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/invite';
    }
    return this.httpClient.post<ApiResponseModel<TenantHdrContainerModel>>(
      this.apiUrl,
      tenantHdr,
      this.getHttpHeader(visa)
    );
  }

  sendInvitationResponse(response: string, tenantCode: string, visa: ApiVisa): Observable<ApiResponseModel<TenantHdrContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' +
        tenantCode + '/invitation-response?response=' + response
    }
    var dtoObject = {};
    return this.httpClient.put<ApiResponseModel<TenantHdrContainerModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  getConnectedTenants(visa: ApiVisa): Observable<ApiResponseModel<TenantHdrContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + 'query?obj_status=CONNECTED&calcTotalRecords=true&obj_access=HOST'
    }
    return this.httpClient.get<ApiResponseModel<TenantHdrContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }
  getTenantPerm(visa: ApiVisa): Observable<ApiResponseModel<TenantHdrContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + 'query?calcTotalRecords=true&obj_type=T2T&obj_access=GUEST&obj_status = CONNECTED'
    }
    return this.httpClient.get<ApiResponseModel<TenantHdrContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }
}